import type { ISerialize } from '@/objects/ISerialize';

export class DeviceStatusStation implements ISerialize {
    public ID: number;

    public EventID: number;

    public EventName: string | null;

    public Name: string | null;

    public SortOrder: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { ID?: number; EventID?: number; EventName?: string | null; Name?: string | null; SortOrder?: number }) {
        this.ID = values.ID ?? 0;

        this.EventID = values.EventID ?? 0;

        this.EventName = values.EventName ?? null;

        this.Name = values.Name ?? null;

        this.SortOrder = values.SortOrder ?? 0;
    }

    public serialize(): string {
        return (
            '{' +
            `"ID": ${JSON.stringify(this.ID)}` +
            ',' +
            `"EventID": ${JSON.stringify(this.EventID)}` +
            ',' +
            `"EventName": ${JSON.stringify(this.EventName)}` +
            ',' +
            `"Name": ${JSON.stringify(this.Name)}` +
            ',' +
            `"SortOrder": ${JSON.stringify(this.SortOrder)}` +
            '}'
        );
    }

    /**
     * Creates an instance of DeviceStatusStation from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        ID?: number;
        EventID?: number;
        EventName?: string | null;
        Name?: string | null;
        SortOrder?: number;
    }): DeviceStatusStation {
        return new DeviceStatusStation(values);
    }

    public static _FromServerJson(json: any): DeviceStatusStation {
        return new DeviceStatusStation({
            ID: json.ID,
            EventID: json.EventID,
            EventName: json.EventName ?? '',
            Name: json.Name ?? '',
            SortOrder: json.SortOrder,
        });
    }

    /**
     * Creates an instance of DeviceStatusStation from another instance of DeviceStatusStation.
     * @param other The DeviceStatusStation you want to clone
     * @returns A cloned DeviceStatusStation
     */
    public static FromOther(other: DeviceStatusStation): DeviceStatusStation {
        return DeviceStatusStation._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return DeviceStatusStation.FromOther(this);
    }

    static NAME_OF_CLASS = 'DeviceStatusStation';
}
